import React, { useState } from "react";
import * as m5 from '@mobiscroll/react5'


const MemoEditor = ({ isOpen, memo, onSave, onCancel }) => {

    const [memoStr, setMemoStr] = useState(memo)

    const btns = [
        {
            text: '取消',
            cssClass: 'float-left',
            handler: ()=>{
                setMemoStr(memo)
                onCancel()
            }
        },
        {
            text: '確定',
            handler: () => { onSave(memoStr) }
        }
    ]

    return (
        <m5.Popup isOpen={isOpen} buttons={btns} >
            <h5 className="mx-2">個股操作備註</h5>
            <m5.Textarea
                className="mx-2 mb-1"
                name="memo"
                defaultValue={memoStr}
                placeholder="至多100字"
                maxLength="100"
                rows={10}
                onChange={ev => setMemoStr(ev.target.value)}
                inputStyle="box"
                >
            </m5.Textarea>
        </m5.Popup>
    )

}

export default MemoEditor